module.exports = __webpack_public_path__ + "static/vehicle-wraps-banner-236ccc3dfa0cb6b2f26212302bc30a21.jpg";